/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeSlotEnum = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type TeamSettingsAdminTeamCalendar_org = {
    readonly id: string;
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly teamSettings: {
        readonly __typename: "TeamSettings";
        readonly manageTeamCalendar: boolean;
        readonly syncWFHEvents: boolean;
        readonly minimumMinutesForSyncing: number;
        readonly slackSettings: {
            readonly notificationEnabled: boolean;
            readonly channelId: string | null;
            readonly timeSlot: TimeSlotEnum | null;
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "TeamSettingsAdminTeamCalendar_org";
};
export type TeamSettingsAdminTeamCalendar_org$data = TeamSettingsAdminTeamCalendar_org;
export type TeamSettingsAdminTeamCalendar_org$key = {
    readonly " $data"?: TeamSettingsAdminTeamCalendar_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamSettingsAdminTeamCalendar_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "teamId"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamSettingsAdminTeamCalendar_org",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "experiments",
            "storageKey": null
        },
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "teamId",
                    "variableName": "teamId"
                }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "teamSettings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "manageTeamCalendar",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "syncWFHEvents",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minimumMinutesForSyncing",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamSlackSettings",
                            "kind": "LinkedField",
                            "name": "slackSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "notificationEnabled",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "channelId",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "timeSlot",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "type": "TeamSettings",
                    "abstractKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "statusCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "type": "GraphEntityError",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = '2825296d07556643a357945b672a74ff';
export default node;
